import CompararPreciosProveedorPage from "../pages/CompararPreciosProveedorPage";

const routes = [
  {
    name: "CompararPreciosProveedorPage",
    path: "/comparar-precios-proveedor",
    component: CompararPreciosProveedorPage,
    meta: {
      requiresAuth: true,
      permission: "LISTA_PRECIOS_PROVEEDOR_IMPORTAR",
    },
  },
];

export default routes;
